import React from 'react'
import Chip from 'components/Chip'
import Button from 'components/Button'

/**
 * @param label
 * @param onClick
 * @param isSelected
 * @returns {JSX.Element}
 * @constructor
 */
export function ChipPressable ({
  label,
  onClick,
  isSelected
}) {
  return (
    <Button
      key={label}
      onClick={onClick}
      height='auto'
    >
      <Chip
        py='0.5rem'
        px='0.5rem'
        isSelected={isSelected}
      >
        {label}
      </Chip>
    </Button>
  )
}
